// extracted by mini-css-extract-plugin
export default {"tabContent":"TabsContainer_tabContent__IFHhZ"};